import { UnitSummaryModel, PropertySummary } from 'api/models';
import { flatten } from 'es-toolkit/compat';
import HomeownerAccountProperty from 'models/homeownerAccounts/HomeownerAccountProperty';

type UnitWithProperty = UnitSummaryModel & {
  property: PropertySummary;
};

export function getUnitsFromProperties(
  homeownerProperties: HomeownerAccountProperty[],
): UnitWithProperty[] {
  return flatten(
    homeownerProperties?.map((property) =>
      property.units.map((unit: any) => {
        return {
          ...unit,
          property,
        };
      }),
    ),
  );
}
